import { useDispatch, useSelector } from 'react-redux';

import Button from 'atoms/button';
import Checkbox from 'atoms/checkbox';
import Dropdown from 'atoms/dropdown';
import Icon from 'atoms/icon';
import {
  addService,
  editService,
  setAddAllState,
  setAllServices,
} from 'store/reducers/groomerForm';
import { getServiceNameWithTags } from 'util';
import { catAndDogTypeId, durationOptions } from 'util/constants';

import { defaultService } from '../GroomerEdit';
import NoServices from './NoServices';

const renderIcon = () => (
  <Icon
    name="close"
    className="plus-icon mr-10"
    style={{ fill: '#cacad9', width: 12, height: 12 }}
  />
);

// This refers to services and add-ons
export default function Services() {
  const dispatch = useDispatch();
  const locationServices =
    useSelector((state) => state.provider.locations?.[0]?.services) || [];
  const { servicedAnimals, services, isAddAllSelected } = useSelector(
    (state) => state.groomerForm
  );

  const servicesByType = locationServices
    .map((service) => {
      if (
        servicedAnimals?.[0]?.id === catAndDogTypeId ||
        servicedAnimals?.[0]?.id === service.animal?.type?.id
      ) {
        return {
          durationMinutes: {
            value: `${service.durationMinutes} min`,
            id: service.durationMinutes,
          },
          name: getServiceNameWithTags(service),
          uuid: service.uuid,
        };
      }
      return null;
    })
    .filter(Boolean);
  const noServicedAnimals = servicedAnimals.length === 0;
  const noServicesAvailable = servicesByType.length === 0;

  const toggleAddAllServices = (isChecked) => {
    dispatch(setAllServices(isChecked ? servicesByType : defaultService));
    dispatch(setAddAllState(isChecked));
  };

  const onDeleteService = (uuid) => {
    dispatch(
      setAllServices(services.filter((service) => service.uuid !== uuid))
    );
  };

  return (
    <div className="groomer-drawer-services p-24 radius-24 mt-12 border-light-purple">
      <h4 className="mb-8">Services</h4>
      {noServicesAvailable || noServicedAnimals ? (
        <NoServices
          reason={
            noServicedAnimals ? 'no-serviced-animals' : 'no-services-available'
          }
        />
      ) : (
        <div>
          {services.map((service, index) => (
            <div className="flex-row justify-between mb-8" key={service.uuid}>
              <div className="flex-row w-100">
                <Dropdown
                  id="service-name"
                  size="small"
                  variant="white"
                  className="w-66 mr-10"
                  value={service.name}
                  disabledValues={services.map((service) => service.uuid)}
                  items={servicesByType}
                  placeholder="Select service"
                  onClick={(service) => {
                    const { uuid, name } = service;
                    dispatch(editService({ index, value: uuid, key: 'uuid' }));
                    dispatch(editService({ index, value: name, key: 'name' }));
                  }}
                />
                <Dropdown
                  id="service-duration"
                  size="small"
                  variant="white"
                  className="w-33 mr-15"
                  value={service.durationMinutes}
                  items={durationOptions}
                  onClick={(value) =>
                    dispatch(
                      editService({ index, value, key: 'durationMinutes' })
                    )
                  }
                />
              </div>
              {index > 0 && (
                <Icon
                  name="bin"
                  onClick={() => onDeleteService(service.uuid)}
                />
              )}
            </div>
          ))}
          <div className="flex-row mt-10">
            {services.length !== servicesByType.length && (
              <Button
                size="small"
                className="fw-400 mr-10"
                variant="white-outlined"
                iconPosition="start"
                customElement={renderIcon()}
                onClick={() => dispatch(addService())}
                text="Add service"
              />
            )}
            <Checkbox
              id="add-all"
              value={isAddAllSelected}
              variant="button"
              onClick={({ isChecked }) => toggleAddAllServices(isChecked)}
            >
              <p>Add all</p>
            </Checkbox>
          </div>
        </div>
      )}
    </div>
  );
}
